import { Directive } from '@angular/core';

@Directive({
  selector: '[libDummyContainer]'
})
export class DummyContainerDirective {}
